    (function () {
      var root = document.documentElement;
      var HCLASS = 'additional-checkout-buttons--horizontal';
      root.classList.add(HCLASS);

      var HOST = 'shopify-accelerated-checkout-cart';
      var GP = 'shopify-google-pay-button';
      var MARK = 'data-ho-no-gpay';
      var PROBE = 'data-ho-gpay-probe';
      var FLAG = 'hoNoGpay';
      var PROBED = 'hoGpayProbe';
      var FRESH = HOST + ':not([' + MARK + ']):not([' + PROBE + '])';

      var IOS = /iP(hone|ad|od)/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

      function get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
      function set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
      function noGpay() { return IOS || get(FLAG) === '1'; }
      function remember() { set(FLAG, '1'); set(PROBED, 'no'); }
      /* Shopify's own "this device cannot use Google Pay" mark. */
      function gpRefused(gp) {
        return gp.style.getPropertyValue('display') === 'none';
      }

      function rebuild(host) {
        if (!host.isConnected || host.hasAttribute(PROBE)) return;
        var cfg;
        try { cfg = JSON.parse(host.getAttribute('wallet-configs') || '[]'); } catch (e) { cfg = null; }
        if (!Array.isArray(cfg)) { host.setAttribute(MARK, ''); return; }
        var kept = cfg.filter(function (w) { return !w || w.name !== 'google_pay'; });
        if (kept.length === cfg.length || !kept.length) { host.setAttribute(MARK, ''); return; }
        var fresh = document.createElement(HOST);
        for (var i = 0; i < host.attributes.length; i++) {
          fresh.setAttribute(host.attributes[i].name, host.attributes[i].value);
        }
        fresh.setAttribute('wallet-configs', JSON.stringify(kept));
        fresh.setAttribute(MARK, '');
        host.replaceWith(fresh);
      }
      function rebuildAll() {
        var hosts = document.querySelectorAll(FRESH);
        for (var i = 0; i < hosts.length; i++) rebuild(hosts[i]);
      }

      /* 1. Swap before first paint. Observer callbacks are microtasks: they run
            right after the theme inserts the drawer (or the parser inserts the
            cart page) and before the browser draws a frame.
         2. Safety net: react the instant Shopify hides Google Pay in a real
            (non-probe) wallet element. */
      /* Style changes are watched only inside wallet elements. */
      var styleMo = window.MutationObserver ? new MutationObserver(function (records) {
        for (var r = 0; r < records.length; r++) {
          var t = records[r].target;
          if (t.localName !== GP || !gpRefused(t)) continue;
          var host = t.parentElement;
          if (!host || host.localName !== HOST || host.hasAttribute(PROBE) || !host.isConnected) continue;
          remember();
          rebuild(host);
        }
      }) : null;
      function watch(host) {
        if (!styleMo || host.__hoGpWatch || host.hasAttribute(PROBE)) return;
        host.__hoGpWatch = true;
        styleMo.observe(host, { subtree: true, attributes: true, attributeFilter: ['style'] });
      }
      function handleAdded(node) {
        if (node.nodeType !== 1) return;
        var hosts = node.localName === HOST ? [node] :
          (node.firstElementChild ? node.querySelectorAll(HOST) : []);
        for (var i = 0; i < hosts.length; i++) {
          var h = hosts[i];
          if (noGpay() && !h.hasAttribute(MARK) && !h.hasAttribute(PROBE)) { rebuild(h); continue; }
          watch(h);
        }
      }
      if (window.MutationObserver) {
        new MutationObserver(function (records) {
          for (var r = 0; r < records.length; r++) {
            var added = records[r].addedNodes;
            for (var n = 0; n < added.length; n++) handleAdded(added[n]);
          }
        }).observe(root, { childList: true, subtree: true });
      }
      /* Wallet elements already in the page when this runs (cart page). */
      Array.prototype.forEach.call(document.querySelectorAll(HOST), watch);

      /* Background probe: learn, before the shopper opens the cart, whether
         Google Pay can show on this device. */
      function probe() {
        if (noGpay() || get(PROBED)) return;
        var tpl = document.querySelector('[data-cart-drawer-template]');
        var src = (tpl && tpl.content && tpl.content.querySelector(HOST)) ||
          document.querySelector(HOST + '[' + MARK + ']') ||
          document.querySelector(FRESH);
        if (!src) return;
        var cfg;
        try { cfg = JSON.parse(src.getAttribute('wallet-configs') || '[]'); } catch (e) { return; }
        if (!Array.isArray(cfg) || !cfg.some(function (w) { return w && w.name === 'google_pay'; })) {
          set(PROBED, 'n/a');
          return;
        }
        var box = document.createElement('div');
        box.setAttribute('aria-hidden', 'true');
        box.setAttribute('inert', '');
        box.className = 'additional-checkout-buttons';
        box.style.cssText = 'position:fixed;left:-10000px;top:0;width:360px;' +
          'visibility:hidden;pointer-events:none;contain:strict;height:60px;overflow:hidden;';
        var el = document.createElement(HOST);
        for (var i = 0; i < src.attributes.length; i++) {
          if (src.attributes[i].name !== MARK) el.setAttribute(src.attributes[i].name, src.attributes[i].value);
        }
        el.setAttribute('wallet-configs', JSON.stringify(cfg));
        el.setAttribute(PROBE, '');
        box.appendChild(el);
        document.body.appendChild(box);
        var t0 = Date.now();
        var iv = setInterval(function () {
          var gp = el.querySelector(GP);
          var refused = gp && gpRefused(gp);
          if (refused) {
            remember();
            rebuildAll();
          } else if (Date.now() - t0 < 8000) {
            return;
          } else {
            set(PROBED, 'ok');
          }
          clearInterval(iv);
          box.remove();
        }, 150);
      }
      function startProbe() {
        if (noGpay() || get(PROBED)) return;
        if (window.requestIdleCallback) requestIdleCallback(probe, { timeout: 2500 });
        else setTimeout(probe, 1200);
      }
      /* Start after the first sign of a real visitor (scroll / tap / key),
         once the page has loaded. */
      var EVTS = ['scroll', 'pointerdown', 'touchstart', 'keydown'];
      var armed = false;
      function onFirstUse() {
        if (armed) return;
        armed = true;
        EVTS.forEach(function (ev) { window.removeEventListener(ev, onFirstUse, true); });
        if (document.readyState === 'complete') startProbe();
        else window.addEventListener('load', startProbe);
      }
      if (!noGpay() && !get(PROBED)) {
        EVTS.forEach(function (ev) { window.addEventListener(ev, onFirstUse, { capture: true, passive: true }); });
      }

      /* Keep the layout class in place if anything ever rewrites <html>'s class. */
      if (window.MutationObserver) {
        new MutationObserver(function () {
          if (!root.classList.contains(HCLASS)) root.classList.add(HCLASS);
        }).observe(root, { attributes: true, attributeFilter: ['class'] });
      }
    })();
